// Angular
import {
  Component,
  ViewChild,
  OnInit,
  ElementRef,
  HostListener,
} from "@angular/core";
// Models
import { Post } from "./../../models/post";
// External
import {
  AngularFireDatabase,
  FirebaseListObservable,
} from "angularfire2/database";
import * as lodash from "lodash";
import { Attachment } from "./../../models/attachment";
import { FirebaseApp } from "angularfire2";
import * as moment from "moment";
import { Subject } from "rxjs/Subject";
import { DatePipe } from "@angular/common";
import { ApiService } from "../../services/api";
import { OAuthService } from "app/services/o-auth";

@Component({
  selector: "app-post-report",
  templateUrl: "./post-report.component.html",
})
export class PostReportComponent implements OnInit {
  public posts: Array<Post>;
  public nextKey: any;
  public prevKeys: Array<any>;
  public text: string;
  private offsetPosts: number;
  public filterargs: Post;
  public postData: any;
  public query: string;
  public imageLoader = true;
  public likeCount: number;
  public commentCount: number;
  public mentionCount: number;
  public unappropiateReasons: any;
  public activeIndex: number;
  public isPostShow = true;
  public date: any;
  public club: any;
  constructor(
    private fireDatabase: AngularFireDatabase,
    private oAuthService: OAuthService,
    private apiService: ApiService,
    private datePipe: DatePipe,
    private firebase: FirebaseApp
  ) {
    this.prevKeys = [];
    this.offsetPosts = 20;
    this.query = "";
    this.filterargs = new Post();

    this.activeIndex = -1;
    var currentYear = new Date().getFullYear();
    var diff = currentYear - 2017;
    this.club = this.oAuthService.getClub();
  }
  ngOnInit() {
    this.unappropiateReasons = {
      inappropriate1: "I just don't like it",
      inappropriate2: "Nudity or pornography",
      inappropriate3:
        "Hate speech or symbols \n Racist, homophobic or sexist slurs",
      inappropriate4:
        "Violence or threat of violence \n Graphics injury, unlawful activity, dangerous or criminal organizations",
      inappropriate5: "Sale or promotion of firearms",
      inappropriate6: "Sale or promotion of drugs",
      inappropriate7: "Harassment or bullying",
      inappropriate8:
        "Intellectual property violation \n Copyright or trademark infringement",
      inappropriate9: "Self injury",
      inappropriate10:
        "False Information \n Eating disorders, cutting or promotion suicide",

      spam1: "Spam",
    };
    this.initPostsList();
  }

  public dateChange(event) {
    this.filterargs.date = this.datePipe.transform(event, "yyyy-MM-dd");
  }

  initPostsList() {
    this.posts = [];

    let count = 0;
    const fireObject = this.fireDatabase
      .object(`post-reports`)
      .subscribe((result) => {
        lodash.forEach(result, async (item, key) => {
          console.log(Object.keys(item), key);
          if (this.club.cid == Object.keys(item)[0]) {
            let post = await this.getPost(Object.keys(item)[0], key);
            let report = item[Object.keys(item)[0]];
            post.report_reason = this.unappropiateReasons[
              report["report_type"]
            ];
            const date = new Date(report.timestamp * 1000);
            post.reportUserId = report.userId;
            const o =
              date.getFullYear() +
              "-" +
              ("0" + (date.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + date.getDate()).slice(-2);
            post.date = o;
            this.posts.push(post);
            ++count;

            if (count == 1) this.postDetail(post);
          }
        });
        if (fireObject) {
          fireObject.unsubscribe();
          this.imageLoader = false;
        }
      });
  }
  async getUser(uid) {
    let promise = new Promise((resolve, reject) => {
      if (typeof uid == "string") {
        this.apiService.object("users/" + uid).then((result) => {
          result.key = uid;
          resolve(result);
        });
      }
    });
    return promise;
  }
  getPost(autherId, postID) {
    let promise = new Promise<any>((resolve, reject) => {
      this.apiService
        .object("users-posts/" + autherId + "/" + postID)
        .then((result) => {
          result.postId = postID;
          resolve(result);
        });
    });
    return promise;
  }
  async postDetail(post: Post) {
    $("html, body").animate({ scrollTop: "1px" });

    this.postData = post;
    this.postData.report = await this.getUser(this.postData.reportUserId);
    console.log(this.postData);

    this.text = this.postData.text;
    this.fireDatabase.object(`/users/${post.author}`).subscribe((user: any) => {
      this.postData.authorName = user.username;
      this.postData.authorImage = user.avatar_thumb;
    });
    if (this.postData.mentioned) {
      this.mentionCount = 0;
      lodash.forEach(this.postData.mentioned, (mention, key) => {
        this.mentionCount++;
      });
    }
  }

  showChange(flag) {
    this.isPostShow = flag;
  }
  deletePost(post: any) {
    const index = this.posts.indexOf(post);
    this.posts.splice(index, 1);

    this.apiService.set("post-reports/" + post.postId, null);
    // this.apiService.set("user-post-reports/"+)
  } // --------------------------------------edit text of modal post text--------------------------------
}
